
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { ServiceBase } from '@app/services/base.service';
import { PesquisaRelatorio } from '@app/models/pesquisa-relatorio';
import { LancamentoPesquisa } from '@app/pages/financeiro/lancamento/lancamento.model';
import { FiltrosClientesRelatorios } from '@app/pages/relatorios/clientes/clientes-relatorios';
import { FiltrosReceberAtrasadosRelatorios } from '@app/models/receber-atrasados-relatorios';
import { ProcessosFiltradosFiltro } from '@app/models/relatorios-processos-filtrados';
import { PrazoProtocolo, PrazoProtocoloFiltro } from '@app/models/prazo-protocolo';
import { FiltroRelatorioMeAvise } from '@app/pages/relatorios/me-avise/me-avise-relatorio';
import { RelatorioPublicacao } from '@app/models/relatorio-publicacao';
import { FiltrosPagasPagar } from '../pages/relatorios/pagas-pagar/filtros-pagas-pagar';
import { MovimentacaoLancamento } from '@app/pages/financeiro/lancamento/lancamento.model';
import { ContasPagar } from '../models/contas-pagar';
import { ContasPagas } from '../models/contas-pagas';
import { MetaVisaoMensalDTO } from '@app/pages/relatorios/meta-novos-processos/meta-visao-mensal/relatorio-meta-visao-mensal';
import { FiltroMetaDetalhes, MetaAnualDetalhes, MetaVisaoAnualDTO } from '@app/pages/relatorios/meta-novos-processos/meta-visao-anual/relatorio-meta-visao-anual';
import { FaturamentoTipoAcao } from '@app/models/relatorio-faturamento-tipo-acao';
import { FiltroFaturamentoPorTipoAcao } from '@app/pages/relatorios/faturamento/faturamento-por-tipo-acao/filtro-faturamento-por-tipo-acao';
import { FiltrosNotaFiscal, NotaFiscalRelatorioItem } from '@app/pages/relatorios/nota-fiscal/relatorio-nota-fiscal';
import { FiltrosRequisicaoFinanceira, RelatorioRequisicaoFinanceira } from '@app/models/relatorio-rpv-precatorio.model';

@Injectable()
export class RelatorioService extends ServiceBase {
  constructor(
    private http: HttpClient,
  ) {
    super();
  }

  extratosBancarios(dataInicial: string, dataFinal: string, contasId: number[]): Observable<any> {
    return this.http.get<any>(this.URL_API + `relatorios/extratosBancarios?contasId=${contasId.toString()}
                                          &dataInicial=${encodeURIComponent(dataInicial)}
                                          &dataFinal=${encodeURIComponent(dataFinal)}`);
  }

  // meAvise(somenteNaoRealizadas: boolean, dataInicial: string, dataFinal: string, filtroUsuarioAtualId: number = 0): Observable<any> {
  //   return this.http.get<any>(this.URL_API + `relatorios/meAvise?somenteNaoRealizadas=${somenteNaoRealizadas}
  //                                         &dataInicial=${encodeURIComponent(dataInicial)}
  //                                         &dataFinal=${encodeURIComponent(dataFinal)}
  //                                         &filtroUsuarioAtualId=${filtroUsuarioAtualId}`);
  // }

  meAviseRelatorio(filtros: FiltroRelatorioMeAvise): Observable<any> {
    return this.http.post<any>(this.URL_API + 'relatorios/meAvise', filtros, { headers: { meta: ['search'] } });
  }

  buscarProtocolados(filtro: PrazoProtocoloFiltro): Observable<PrazoProtocolo[]> {
    return this.http
      .get<PrazoProtocolo[]>(this.URL_API + `relatorios/protocolosDiarios?tipo=${filtro.Tipo}&areaId=${filtro.AreaId}&data=${filtro.DataPesquisa}`, { headers: { meta: ['search'] } })
      .pipe(
        catchError((error: any) => observableThrowError(error))
      );
  }

  buscarPublicacoes(areaId: number, data: string): Observable<RelatorioPublicacao[]> {
    return this.http
      .get<RelatorioPublicacao[]>(
        this.URL_API + `relatorios/publicacoesDiarias?areaId=${areaId}&data=${data}`, { headers: { meta: ['search'] } }
      ).pipe(
        catchError((error: any) => observableThrowError(error))
      );
  }

  processosfiltrados(filtro: ProcessosFiltradosFiltro): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `relatorios/ProcessosFiltrados`, filtro, { headers: { meta: ['search'] } }).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  // TODO Recurso não está sendo utilizado, pode ser removido
  // processoSemMovimentacao(tipoProcesso: string, estadoProcessoId: number, unidadeId: number): Observable<any> {
  //   return this.http.get<any>(this.URL_API + `relatorios/ProcessoSemMovimentacao?tipo=${tipoProcesso}&estadoId=${estadoProcessoId}&unidadeId=${unidadeId}`).pipe(
  //     catchError((error: any) => observableThrowError(error)));
  // }

  obterFinanceiroProcesso(processoId: number, pagina: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `relatorios/obterFinanceiroProcesso/?processoId=${processoId}&pagina=${pagina}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  prestacaoContas(processoId: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `relatorios/prestacaoDeContas/?processoId=${processoId}`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  custosProcesso(processoId: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `relatorios/custosProcesso/?processoId=${processoId}`, { headers: { meta: ['search'] } }).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  custosProcessoProcessos(participanteId: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `relatorios/custosProcesso/processos/${participanteId}`);
  }

  extratoParticipante(filtros: any): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'relatorios/extratoParticipante', filtros, { headers: { meta: ['search'] } }).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  logs(filtros: any): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'relatorios/Logs', filtros, { headers: { meta: ['search'] } }).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  pagar(filtros: FiltrosPagasPagar): Observable<ContasPagar[]> {
    const dados = { ...filtros };
    if (!dados.ProcessoId) {
      dados.ProcessoId = 0;
    }

    return this.http
      .post<any>(this.URL_API + 'relatorios/pagar', dados, { headers: { meta: ['search'] } }).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  pagarRestrito(filtros: FiltrosPagasPagar): Observable<ContasPagar[]> {
    const dados = { ...filtros };
    if (!dados.ProcessoId) {
      dados.ProcessoId = 0;
    }

    return this.http
      .post<any>(this.URL_API + 'relatorios/pagar-restrito', dados, { headers: { meta: ['search'] } }).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  receber(filtros: any): Observable<any> {
    const dados = { ...filtros };
    if (!dados.ProcessoId) {
      dados.ProcessoId = 0;
    }
    dados.ProcessoId = parseInt(dados.ProcessoId.toString().trim(), 10);

    return this.http
      .post<any>(this.URL_API + 'relatorios/receber', dados, { headers: { meta: ['search'] } }).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  acordoTrabalhista(filtros: any): Observable<any> {
    const dados = { ...filtros };
    if (!dados.ProcessoId) {
      dados.ProcessoId = 0;
    }
    dados.ProcessoId = parseInt(dados.ProcessoId.toString().trim(), 10);

    return this.http
      .post<any>(this.URL_API + 'relatorios/acordoTrabalhista', dados, { headers: { meta: ['search'] } }).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  faturamentoPorTipoDeAcao(filtros: FiltroFaturamentoPorTipoAcao): Observable<FaturamentoTipoAcao[]> {
    return this.http
      .post<FaturamentoTipoAcao[]>(
        this.URL_API + 'relatorios/faturamentoPorTipoDeAcao', filtros,
        { headers: { meta: ['search'] } }
      ).pipe(
        catchError((error: any) => observableThrowError(error))
    );
  }

  pagas(filtros: FiltrosPagasPagar): Observable<ContasPagas[]> {
    const dados = { ...filtros };
    if (!dados.ProcessoId) {
      dados.ProcessoId = 0;
    }
    dados.ProcessoId = parseInt(dados.ProcessoId.toString().trim(), 10);

    return this.http
      .post<any>(this.URL_API + 'relatorios/pagas', dados, { headers: { meta: ['search'] } }).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  pagasRestrito(filtros: FiltrosPagasPagar): Observable<ContasPagas[]> {
    const dados = { ...filtros };
    if (!dados.ProcessoId) {
      dados.ProcessoId = 0;
    }
    dados.ProcessoId = parseInt(dados.ProcessoId.toString().trim(), 10);

    return this.http
      .post<any>(this.URL_API + 'relatorios/pagas-restrito', dados, { headers: { meta: ['search'] } }).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  pagasEpagar(filtros: any): Observable<any> {

    const dados = { ...filtros };
    if (!dados.ProcessoId) {
      dados.ProcessoId = 0;
    }
    dados.ProcessoId = parseInt(dados.ProcessoId.toString().trim(), 10);

    return this.http
      .post<any>(this.URL_API + 'relatorios/pagas-pagar', dados).pipe(
        catchError((error: any) => observableThrowError(error.json())));
  }

  receberAtrasados(filtros: FiltrosReceberAtrasadosRelatorios): Observable<any> {
    const dados = { ...filtros };
    if (!dados.ProcessoId) {
      dados.ProcessoId = 0;
    }
    dados.ProcessoId = parseInt(dados.ProcessoId.toString().trim(), 10);

    return this.http
      .post<any>(this.URL_API + 'relatorios/receberAtrasados', dados, { headers: { meta: ['search'] } }).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  // obterAgrupadasPagar(pagarId: number): Observable<any> {
  //   return this.http
  //     .post<any>(this.URL_API + `pagar/obterAgrupadasPagar/?pagarId=${pagarId}`)
  //     .catch((error: any) => Observable.throw(error.json()));
  // }
  //  TODO não sendo usado pelo sistema

  // obterAgrupadasReceber(receberId: number): Observable<any> {
  //   return this.http
  //     .post<any>(this.URL_API + `receber/obterAgrupadasReceber/?receberId=${receberId}`)
  //     .catch((error: any) => Observable.throw(error.json()));
  // }
  //  TODO não sendo usado pelo sistema

  recebidas(filtros: any): Observable<any> {

    const dados = { ...filtros };
    if (!dados.ProcessoId) {
      dados.ProcessoId = 0;
    }
    dados.ProcessoId = parseInt(dados.ProcessoId.toString().trim(), 10);

    return this.http.post<any>(this.URL_API + 'relatorios/recebidas', dados, { headers: { meta: ['search'] } }).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  faturamentoRecebidas(filtros: any): Observable<any> {

    const dados = { ...filtros };
    if (!dados.ProcessoId) {
      dados.ProcessoId = 0;
    }
    dados.ProcessoId = parseInt(dados.ProcessoId.toString().trim(), 10);

    return this.http.post<any>(this.URL_API + 'relatorios/faturamentoRecebidas', dados, { headers: { meta: ['search'] } }).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  cheques(filtros: any): Observable<any> {
    return this.http.post<any>(this.URL_API + 'relatorios/cheques', filtros, { headers: { meta: ['search'] } }).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  dr(unidadeId: number, dataInicial: string, dataFinal: string, regime: string, contaId: number): Observable<any> {

    const data = {
      unidadeId: unidadeId,
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      regime: regime,
      contaId: contaId
    };

    return this.http.post<any>(this.URL_API + `relatorios/dr/`, data, { headers: { meta: ['search'] } }).pipe(
      catchError((error: any) => observableThrowError(error)));
  }


  drPorTipo(tipoId: number, dataInicial: string, dataFinal: string, regime: string): Observable<any> {

    const data = {
      tipoId: tipoId,
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      regime: regime
    };

    return this.http
      .post<any>(this.URL_API + `relatorios/DRPorTipo/`, data, { headers: { meta: ['search'] } }).pipe(
        catchError((error: any) => observableThrowError(error)));
  }


  prazos(): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `relatorios/prazos`).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  obterContasAPagarValidadas(pesquisa: PesquisaRelatorio): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'relatorios/ValidacaoPagarPorDia', pesquisa).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  obterCaixa(pesquisa: PesquisaRelatorio): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'relatorios/obterCaixa', pesquisa).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  extratoBancario(lancamentoPesquisa: LancamentoPesquisa, tipoPesquisa: string): Observable<any> {
    return this.http.post<any>(this.URL_API + `relatorios/ExtratoBancario?tipoPesquisa=${tipoPesquisa}`, lancamentoPesquisa, { headers: { meta: ['search'] } }).pipe(
      catchError((error: any) => observableThrowError(error)));
  }


  fluxoDeCaixaDiario(pesquisa: any): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `relatorios/FluxoDeCaixaDiario`, pesquisa, { headers: { meta: ['search'] } }).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  fluxoDeCaixaDiarioResumo(pesquisa: any): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `relatorios/FluxoDeCaixaDiarioResumo`, pesquisa).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  previsaoFluxoDeCaixaDiario(pesquisa: any): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `relatorios/PrevisaoFluxoDeCaixaDiario`, pesquisa, { headers: { meta: ['search'] } }).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  previsaoFluxoDeCaixaDiarioResumo(pesquisa: any): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `relatorios/PrevisaoFluxoDeCaixaDiarioResumo`, pesquisa).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  previsaoMovimentacao(pesquisa: any): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `relatorios/previsaomovimentacao`, pesquisa, { headers: { meta: ['search'] } }).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  clientes(pesquisa: FiltrosClientesRelatorios): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `relatorios/clientes`, pesquisa, { headers: { meta: ['search'] } }).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  // processosPorEstado(estadoId: number, dataInicio?: Date, dataFim?: Date): Observable<any> {
  //   return this.http
  //     .get<any>(this.URL_API + `relatorios/processosPorEstado?estadoDoProcessoId=${estadoId}?dataInicial=${dataInicio}?dataFinal=${dataFim}`).pipe(
  //       catchError((error: any) => observableThrowError(error)));
  // }

  processosPorEstado(estadoId: number, dataInicio?: Date, dataFim?: Date): Observable<any> {
  let params = new HttpParams()
    .set('estadoDoProcessoId', estadoId.toString());

  if (dataInicio) {
    params = params.set('dataInicial', dataInicio.toString()); 
  }
  if (dataFim) {
    params = params.set('dataFinal', dataFim.toString());
  }

  return this.http
    .get<any>(`${this.URL_API}relatorios/processosPorEstado`, { params })
    .pipe(
      catchError((error: any) => error));
}

  //*Anexos*
  obterAnexos(descricao: string, pagina: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `relatorios/ObterAnexos?descricao=${descricao}&pagina=${pagina}`).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  montarArquivoCSV(lancamentoPesquisa: LancamentoPesquisa, tipoPesquisa: string) {
    return this.http.post<any>(this.URL_API + `relatorios/MontarArquivoCSV?tipoPesquisa=${tipoPesquisa}`, lancamentoPesquisa, { headers: { meta: ['search'] } }).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  // Relatório de Metas
  obterRelatorioVisaoMensal(ano: number, mes: number): Observable<MetaVisaoMensalDTO[]> {
    return this.http.get<MetaVisaoMensalDTO[]>(this.URL_API + `relatorios/Metas/Mensal?ano=${ano}&mes=${mes}`).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  obterRelatorioVisaoAnual(ano: number): Observable<MetaVisaoAnualDTO[]> {
    return this.http.get<MetaVisaoAnualDTO[]>(this.URL_API + `relatorios/Metas/Anual?ano=${ano}`).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  obterDetalhesVisaoAnual(filtros: FiltroMetaDetalhes): Observable<MetaAnualDetalhes[]> {
    return this.http.post<MetaAnualDetalhes[]>(this.URL_API + `relatorios/Metas/Anual/Detalhes`, filtros).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  obterRelatorioNotaFiscal(filtros: FiltrosNotaFiscal): Observable<NotaFiscalRelatorioItem[]> {
    return this.http.post<NotaFiscalRelatorioItem[]>(this.URL_API + `relatorios/financeiro/notaFiscal`, filtros).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  obterRelatorioRequisicaoFinanceira(filtros: FiltrosRequisicaoFinanceira): Observable<RelatorioRequisicaoFinanceira[]>{
    return this.http.post<RelatorioRequisicaoFinanceira[]>(this.URL_API + 'relatorios/RequisicaoFinanceira', filtros).pipe(
      catchError((error: any) => observableThrowError(error))
    );
  }

}
